import { useMeasure } from 'react-use';
import Popovers from '../../components/bootstrap/Popovers';

const Footer = () => {
	const [ref, { height }] = useMeasure<HTMLDivElement>();

	const root = document.documentElement;
	root.style.setProperty('--footer-height', `${height}px`);

	const dateobj = new Date();

	let year = dateobj.getFullYear();

	let text = `Gulf Cars Auction @${year}`;
	return (
		<footer ref={ref} className='footer'>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<Popovers title='Footer.tsx'>{text}</Popovers>
					</div>
					<div className='col-auto'>
						<Popovers
							title='Footer.tsx'
							desc={<code>src/layout/Footer/Footer.tsx</code>}>
							Gulf Cars Auction Team
						</Popovers>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
